// fh.js is script-tagged by many fh-* sections, so this file can execute
// a dozen times per page. Without this guard every execution stacked
// duplicate event listeners (13x submit handlers on the buybox form made
// the add-on checkout path submit the form 4-5 times per click).
if (!window.__fhBooted) {
  window.__fhBooted = true;
  var __fhInit = function () {
  // Mobile drawer
  var drawer = document.querySelector('[data-fh-drawer]');
  var toggle = document.querySelector('[data-fh-menu-toggle]');
  var closers = document.querySelectorAll('[data-fh-menu-close]');
  function openMenu() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.setAttribute('data-fh-menu-open', 'true');
  }
  function closeMenu() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.removeAttribute('data-fh-menu-open');
  }
  if (toggle) toggle.addEventListener('click', openMenu);
  closers.forEach(function (el) { el.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  // Reviews carousel
  document.querySelectorAll('[data-fh-reviews]').forEach(function (root) {
    var track = root.querySelector('.fh-reviews__track');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track) return;
    var scrollBy = function () {
      var card = track.querySelector('.fh-review');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    };
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -scrollBy(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: scrollBy(), behavior: 'smooth' }); });
  });

  // Bundle selector
  document.querySelectorAll('[data-fh-bundle]').forEach(function (root) {
    var variantInput = root.querySelector('[data-cart-id]');
    var priceEl = root.querySelector('[data-bundle-price]');
    var comparePriceEl = root.querySelector('[data-bundle-compare]');
    var options = root.querySelectorAll('.fh-bundle__option');

    function setActiveSelectsState() {
      options.forEach(function (o) {
        var active = o.getAttribute('data-active') === 'true';
        o.querySelectorAll('.fh-bundle__per-unit-select').forEach(function (s) { s.disabled = !active; });
        // Disable inactive bundles' hidden Camera Color inputs so they don't submit
        o.querySelectorAll('input[data-camera-color]').forEach(function (h) { h.disabled = !active; });
      });
    }

    function moneyFormat(cents) {
      if (!cents && cents !== 0) return '';
      var n = parseInt(cents, 10);
      if (isNaN(n)) return '';
      return '$' + (n / 100).toFixed(2);
    }

    function parseColorMap(str) {
      var map = {};
      if (!str) return map;
      str.split('|').forEach(function (entry) {
        if (!entry) return;
        var name = entry.split('=')[0];
        var rest = entry.substring(name.length + 1);
        var parts = rest.split('&');
        var data = { id: parts[0] || '' };
        for (var i = 1; i < parts.length; i++) {
          var kv = parts[i].split('=');
          data[kv[0]] = kv[1] || '';
        }
        map[name] = data;
      });
      return map;
    }

    function applySwatch(opt, swatch) {
      var cameraNum = swatch.getAttribute('data-camera');
      var color = swatch.getAttribute('data-color');
      var row = swatch.parentElement;
      row.querySelectorAll('.fh-swatch').forEach(function (s) { s.setAttribute('data-active', 'false'); });
      swatch.setAttribute('data-active', 'true');
      var hidden = opt.querySelector('input[data-camera-color="' + cameraNum + '"]');
      if (hidden) hidden.value = color;
      if (row) row.classList.remove('fh-swatches--missing');
      // Camera #1 drives the actual variant
      if (cameraNum === '1') {
        var map = parseColorMap(opt.getAttribute('data-color-variants'));
        var match = map[color];
        if (match && match.id) {
          opt.setAttribute('data-variant', match.id);
          var radio = opt.querySelector('input[type="radio"]');
          if (radio) radio.value = match.id;
          var newPrice = moneyFormat(match.p);
          var newCompare = moneyFormat(match.c);
          if (newPrice) opt.setAttribute('data-price', newPrice);
          opt.setAttribute('data-compare', newCompare || '');
          var pn = opt.querySelector('.fh-bundle__price-now');
          var pw = opt.querySelector('.fh-bundle__price-was');
          if (pn && newPrice) pn.textContent = newPrice;
          if (pw) pw.textContent = newCompare || '';
          if (opt.getAttribute('data-active') === 'true') {
            if (variantInput) variantInput.value = match.id;
            if (priceEl && newPrice) priceEl.textContent = newPrice;
            if (comparePriceEl) comparePriceEl.textContent = newCompare || '';
            // Swap the main gallery image to the variant's featured image
            if (match.img) {
              var imgUrl = decodeURIComponent(match.img);
              var mainImg = document.querySelector('[data-fh-gallery] [data-main-img]');
              if (mainImg && imgUrl) mainImg.setAttribute('src', imgUrl);
              var thumbs = document.querySelectorAll('[data-fh-gallery] [data-thumb]');
              thumbs.forEach(function (t) {
                var full = t.getAttribute('data-full') || '';
                t.classList.toggle('is-active', full.split('?')[0] === imgUrl.split('?')[0]);
              });
            }
          }
        }
      }
    }

    options.forEach(function (opt) {
      opt.querySelectorAll('.fh-swatch').forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          applySwatch(opt, sw);
        });
      });
      opt.addEventListener('click', function (e) {
        // don't hijack clicks on the per-unit selects/swatches themselves
        if (e.target.closest('.fh-bundle__per-unit-select')) return;
        if (e.target.closest('.fh-swatch')) return;
        options.forEach(function (o) {
          o.setAttribute('data-active', 'false');
          var r = o.querySelector('input[type="radio"]');
          if (r) r.checked = false;
        });
        opt.setAttribute('data-active', 'true');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        var id = opt.getAttribute('data-variant');
        if (variantInput && id) variantInput.value = id;
        var p = opt.getAttribute('data-price');
        var cp = opt.getAttribute('data-compare');
        if (priceEl && p) priceEl.textContent = p;
        if (comparePriceEl) comparePriceEl.textContent = cp || '';
        setActiveSelectsState();
      });
    });

    setActiveSelectsState();

    function setCtaLoading(form) {
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('data-label', btn.textContent.trim());
      btn.innerHTML = '<span class="fh-btn__spinner" aria-hidden="true"></span>Adding to cart...';
    }

    root.addEventListener('submit', function (e) {
      var activeOpt = root.querySelector('.fh-bundle__option[data-active="true"]');
      if (!activeOpt) return;
      var missing = [];
      activeOpt.querySelectorAll('input[data-camera-color]').forEach(function (h) {
        if (h.disabled) return;
        if (!h.value) missing.push(h);
      });
      if (missing.length === 0) {
        setCtaLoading(root);
        // Optional add-on product: add it via AJAX first, then submit the form natively
        var addon = root.querySelector('input[data-fh-addon]:checked');
        if (addon && root.getAttribute('data-addon-added') !== '1') {
          e.preventDefault();
          var finish = function () {
            root.setAttribute('data-addon-added', '1');
            HTMLFormElement.prototype.submit.call(root);
          };
          // update.js sets the addon quantity to exactly 1 (adds it if missing,
          // never stacks duplicates across repeat add-to-cart clicks/visits)
          var updates = {};
          updates[String(parseInt(addon.value, 10))] = 1;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(finish, finish);
        }
        return;
      }
      e.preventDefault();
      missing.forEach(function (h) {
        var num = h.getAttribute('data-camera-color');
        var rowEl = activeOpt.querySelector('.fh-bundle__swatches[data-camera="' + num + '"]');
        if (rowEl) rowEl.classList.add('fh-swatches--missing');
      });
      var firstNum = missing[0].getAttribute('data-camera-color');
      var firstRow = activeOpt.querySelector('.fh-bundle__swatches[data-camera="' + firstNum + '"]');
      if (firstRow) firstRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  });

  // Add-on card: mirror checkbox state onto the card for styling
  document.querySelectorAll('[data-fh-addon-card]').forEach(function (card) {
    var cb = card.querySelector('input[data-fh-addon]');
    if (!cb) return;
    var sync = function () { card.classList.toggle('is-checked', cb.checked); };
    cb.addEventListener('change', sync); sync();
  });

  // PDP thumbnail gallery
  document.querySelectorAll('[data-fh-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-main-img]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-full');
        if (main && src) main.setAttribute('src', src);
      });
    });
    // Swipe main image left/right on touch devices
    var mainWrap = root.querySelector('.fh-pdp__main');
    if (mainWrap && main && thumbs.length > 1) {
      var swipeStartX = 0, swipeStartY = 0, swipeTracking = false;
      var thumbArr = Array.prototype.slice.call(thumbs);
      mainWrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swipeTracking = false; return; }
        swipeTracking = true;
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (!swipeTracking) return;
        swipeTracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - swipeStartX;
        var dy = t.clientY - swipeStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var idx = 0;
        for (var i = 0; i < thumbArr.length; i++) {
          if (thumbArr[i].classList.contains('is-active')) { idx = i; break; }
        }
        var nextIdx = dx < 0 ? idx + 1 : idx - 1;
        if (nextIdx < 0) nextIdx = thumbArr.length - 1;
        if (nextIdx >= thumbArr.length) nextIdx = 0;
        thumbArr[nextIdx].click();
        thumbArr[nextIdx].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }, { passive: true });
    }
    // Thumb strip arrows
    var strip = root.querySelector('[data-fh-thumbs]');
    var prevBtn = root.querySelector('[data-thumb-prev]');
    var nextBtn = root.querySelector('[data-thumb-next]');
    if (strip && prevBtn && nextBtn) {
      var step = function () {
        var firstThumb = strip.querySelector('.fh-pdp__thumb');
        var w = firstThumb ? firstThumb.getBoundingClientRect().width + 6 : 80;
        return w * 3;
      };
      prevBtn.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
      var updateArrowState = function () {
        prevBtn.disabled = strip.scrollLeft <= 2;
        nextBtn.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      };
      strip.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    }
  });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', __fhInit);
  } else {
    __fhInit();
  }

  // Reset ATC button state when returning via back/forward cache
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.fh-btn.is-loading').forEach(function (btn) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      var label = btn.getAttribute('data-label');
      if (label) btn.textContent = label;
    });
  });
}
